import {
  DataTable,
  Dialog,
  FormInput,
  FormSelect,
  Heading,
  Loader,
} from "@/components";
import usePaymentListing from "./usePaymentListing";
import { Button } from "@/components/ui";
import { paymentStatus } from "@/lib/utils";
import { FormProvider } from "react-hook-form";
import {
  parkDocumentSearch,
  postDocumentSearch,
  SEARCH_CRITERIA,
  SEARCH_TYPE,
  searchType,
} from "./consts";

const PaymentListing = () => {
  const {
    breadcrumbData,
    columns,
    globalFilter,
    setGlobalFilter,
    onRowClick,
    paymentAction,
    isDocLoading,
    documentList,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    isDocRefetching,
    form,
    onSubmit,
    requiredFields,
    onClear,
    isPaymentMethodLoading,
    isLoadingGlMaster,
    showLinkPopup,
    setShowLinkPopup,
    invoiceIds,
    viewInvoiceDoc,
    isFromPayment360,
    onBackClick,
    paymentIds,
    viewPaymentDoc
  } = usePaymentListing();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={`Payment ${
              paymentStatus[paymentAction || ""]
                ? "- " + paymentStatus[paymentAction || ""]?.label
                : ""
            }`}
            breadcrumbData={breadcrumbData}
            onBackClick={onBackClick}
            showBack={isFromPayment360}
          />
          {/* {isMobile && <Button className="px-2">+ Add Budget</Button>} */}
        </div>
      </div>

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px] mb-[30px]">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
              <FormSelect
                name={SEARCH_TYPE}
                control={form.control}
                label="Search Type"
                placeholder="Please select"
                error={errors[SEARCH_TYPE]?.message}
                isRequired={requiredFields.includes(SEARCH_TYPE)}
                options={
                  paymentAction == "post"
                    ? [...postDocumentSearch, ...searchType]
                    : [...parkDocumentSearch, ...searchType]
                }
              />
              <FormInput
                name={SEARCH_CRITERIA}
                control={form.control}
                label="Search Criteria"
                placeholder="Please enter"
                error={errors[SEARCH_CRITERIA]?.message}
                isRequired={requiredFields.includes(SEARCH_CRITERIA)}
              />
              <div className="flex flex-row justify-end gap-3 pt-3">
                <Button type="submit">Search</Button>
                <Button variant="outline" type="button" onClick={onClear}>
                  Clear
                </Button>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>

      {/* Responsive Table */}
      {isDocLoading ||
      isDocRefetching ||
      isPaymentMethodLoading ||
      isLoadingGlMaster ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={documentList?.data || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(documentList?.total / pageSize)}
            totalRecords={documentList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
      {showLinkPopup && (
        <Dialog
          open={showLinkPopup}
          setOpen={setShowLinkPopup}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Linked Document"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
          hideFooter
          contentClassName="md:w-[800px]"
        >
          {invoiceIds || paymentIds ? (
            <>
              <div className="text-[14px] font-[400]">
                Select a document below to view its details.
              </div>
              {invoiceIds ? <div className="grid grid-cols-2 gap-6 mt-6">
                <Button onClick={viewInvoiceDoc}>Invoice Document</Button>
              </div> : <></>}
              {paymentIds ? <div className="grid grid-cols-2 gap-6 mt-6">
                <Button onClick={viewPaymentDoc}>Payment Document</Button>
              </div> : <></>}
            </>
          ) : (
            <div>No Linked Document Found</div>
          )}
        </Dialog>
      )}
    </div>
  );
};

export default PaymentListing;
